import React from 'react'

import { Fragment, useState, useCallback, useEffect } from 'react'

import { DateTime } from 'luxon'

import { v4 as uniqid } from 'uuid'

import Loader from '@Pure/Loader'

import ModelPicker from '@/Form/V2/ModelPicker'
import SubmitForm  from '@/Form/V2/SubmitForm'
import DatePicker  from '@/Form/V2/DatePicker'

import BillRows from '@/BillRows'

import getFormStatus from '@/Form/Functions/getFormStatus'

import CreditNotesListInfos from '@/Billing/CreditNotesListInfos'

import removeStatusMsg from '@function/removeStatusMsg'

import FormsStore from '@Store/Forms'

const FORM_NAME = 'CreditNote';

const FORM_INIT =
{
	type: 'on_bill',
	date: DateTime.now().toISODate()
};

export default function CreditNoteForm ({ ...props })
{
	const [submit, setSubmit] = useState();
	const [submitting, setSubmitting] = useState(false);
	const [status, setStatus] = useState({ });

	const picked_bill = FormsStore.useState(s => s[FORM_NAME]?.bill_id || '');

	const removeFieldError = useCallback(function (name)
	{
		setStatus(status => removeStatusMsg(status, name));
	},
	[]);

	useEffect(function ()
	{
		FormsStore.update(function (store)
		{
			store[FORM_NAME] = { ...FORM_INIT };
		});
	},
	[]);

	const sendForm = useCallback(function (e)
	{
		if (submitting) return;

		FormsStore.update(function (store)
		{
			store[FORM_NAME]._submit_id = uniqid();
		});

		setSubmitting(true);
		setSubmit(uniqid());
	},
	[submitting]);

	const onError = useCallback(function (update)
	{
		setSubmit(undefined);
		setStatus(update);
		setSubmitting(false);
	},
	[]);

	const onSuccess = useCallback(function (update)
	{
		setSubmit(undefined);
		setStatus(update);
		setSubmitting(false);

		FormsStore.update(function (store)
		{
			store[FORM_NAME] = { ...FORM_INIT };
		});
	},
	[]);

	const show_rows = picked_bill ? true : false;

	useEffect(function ()
	{
		if (show_rows) setStatus({ });
	},
	[show_rows]);

	const rows_area = show_rows ?
	(
		<div className="u-full-width u-positioned" style={ { minHeight: 200 } }>
			<BillRows form={ FORM_NAME } bill_id={ picked_bill }
				status={ status } mode="credit_note"
			/>
			{
				status.fields?.rows?.error
				? getFormStatus({ error: status.fields.rows.error })
				: undefined
			}
		</div>
	)
	: undefined;

	return (
		<>

			<div className="c-form c-form--credit-note">

				<h2 className="c-title c-title--form">
					Avoir
				</h2>

				<div className="c-form__content-fields u-margin-bottom-20">

					<ModelPicker name="bill_id" key="bill_id"
						label="N° de Facture ou commande"
						model="bill"
						error={ status.fields?.['bill_id']?.error }
						bemit={ ['50%'] }
						form={ FORM_NAME }
						url="/autocomplete/bills"
					/>

				</div>

				{
					picked_bill ?
					(
						<DatePicker name="date"
							label="Date d'émission de l'avoir"
							form={ FORM_NAME }
							error={ status.fields?.['date']?.error }
							removeError={ removeFieldError }
						/>
					)
					: undefined
				}

				{
					picked_bill ?
					(
						<CreditNotesListInfos bill={ picked_bill } />
					)
					: undefined
				}

				{ rows_area }

			</div>

			{
				submit ?
				(
					<SubmitForm form={ FORM_NAME } id={ submit }
						key={ props.type }
						onError={ onError }
						onSuccess={ onSuccess }
						url={
							'/credit-notes/' +
							(props.type === 'create' ? 'create' : 'update')
						}
					/>
				)
				: undefined
			}

			{ getFormStatus(status) }

			<button type="button" className="c-btn c-btn--extra c-btn--green
				u-margin-top-30"
				onClick={ sendForm }
				disabled={ submitting }>
				Valider et créer cet avoir
				{
					submitting ?
					(
						<Loader bemit={ ['bg-green', 'white'] }
							className="c-loader"
						/>
					)
					: undefined
				}
			</button>

		</>
	);
}